import Vue from "vue";
import Router from "vue-router";
import Home from "./views/pages/HomePage.vue";
import ContactUs from "./views/pages/ContactUs.vue";
import AboutUs from "./views/pages/AboutUs.vue";
import Dhanvantari from "./views/pages/products/Dhanvantari.vue";
import Inventory from "./views/pages/products/Inventory.vue";
import School from "./views/pages/products/School.vue";
import Hospital from "./views/pages/products/Hospital.vue";
import WebApp from "./views/pages/services/WebApp.vue";
import DesktopApp from "./views/pages/services/DesktopApp.vue";
import Hosting from "./views/pages/services/Hosting.vue";
import Android from "./views/pages/services/AndroidApp.vue";
import Policy from "./views/pages/shabdarth/Policy.vue";

Vue.use(Router);
export const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/shabdarth/privacy-policy",
    name: "shabarth-privacy",
    component: Policy,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactUs,
  },
  {
    path: "/about",
    name: "about",
    component: AboutUs,
  },
  {
    path: "/dhanvantari",
    name: "dhanvantari",
    component: Dhanvantari,
  },
  {
    path: "/inventory",
    name: "inventory",
    component: Inventory,
  },
  {
    path: "/school",
    name: "school",
    component: School,
  },
  {
    path: "/hospital",
    name: "hospital",
    component: Hospital,
  },
  {
    path: "/web-app",
    name: "web-app",
    component: WebApp,
  },
  {
    path: "/desktop-app",
    name: "desktop-app",
    component: DesktopApp,
  },
  {
    path: "/android-app",
    name: "android-app",
    component: Android,
  },
  {
    path: "/hosting",
    name: "hosting",
    component: Hosting,
  },
];

const router = new Router({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
});

export default router;
